export default "/images/0a214a938f791085386c56a4981ba9da.avif";